import './Buttons.css';

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'danger' | 'popup' | 'close' | 'ghost';
  height?: string;
  size?: 'small' | 'medium' | 'large' | 'round' | 'xlarge';
  background?: 'color1' | 'color2' | 'color3';
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
  className?: string;
}

const Button = ({
  variant = 'primary',
  height = '',
  size = 'medium',
  background,
  disabled,
  onClick,
  children,
  className,
}: ButtonProps) => {
  const buttonClass = `${className ? className : ''} btn btn-${variant} ${background ? `btn-${background}` : ''} btn-${size} ${disabled ? 'btn-disabled' : ''}`;

  return (
    <button className={buttonClass} onClick={onClick} disabled={disabled}>
      {children || (variant === 'close' ? '' : 'Button')}
    </button>
  );
};

export default Button;
